import { CircularProgress } from "@mui/joy";

interface Props {
    isDirty: boolean;
    updateTaskLoading: boolean;
}

export function UpdateTaskInfoButton({ isDirty, updateTaskLoading }: Props) {
    return (
        <>
            {isDirty && (
            <>
            {updateTaskLoading
            ?
            <CircularProgress sx={{
                "--CircularProgress-size": "30px",
                "--CircularProgress-trackThickness": "3px",
                "--CircularProgress-progressThickness": "3px"
            }}/>
            :
            <button
                type="submit"
                className="bg-blue-800 hover:bg-blue-900 h-[30px] rounded px-[15px] py-[4px] flex gap-1 items-center text-white">
                Actualizar
            </button>
            }
            </>
            )}
        </>
    );
}